import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import Check from "../img/CheckButton.svg";
import CallItem from "../img/Call.svg";
import Car from "../img/CarSelect.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { nextPage, dataChange, backPage, nowPage, PDdataChange, PDorderAssignType } from '../slices/counterSlice';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import mixpanel from "mixpanel-browser";
import * as Sentry from "@sentry/react";


const ContentFrame = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 80px;
  @media (max-width: 767px) {
    gap: 36px;
  }
`;

const InfoFrame = styled.div`
  width: 100%;
  border: 1px solid #99a5ac;
  border-radius: 8px;
  background-color: #f3f7fd;
  display: flex;
  flex-direction: column;
`;

const InfoTopFrame = styled.div`
  width: 100%;
  border-bottom: solid 1px #ddd;
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  @media (max-width: 1099px) {
    padding: 20px;
  }
`;

const InfoBottomFrame = styled.div`
  width: 100%;
  padding: 20px 30px;
  display: flex;

  align-items: center;
  @media (max-width: 1099px) {
    padding: 12px 20px;
  }
`;

const InfoTitle = styled.div`
  font-family: Gongim-Medium;
  font-size: 20px;
  color: #222;
  text-align: left;
  @media (max-width: 1099px) {
    font-size: 16px;
  }
`;

const InfoContents = styled.div`
  font-family: Gongim-Reguler;
  font-size: 18px;
  color: #707070;
  line-height: 160%;
  text-align: left;
  @media (max-width: 1099px) {
    font-size: 14px;
  }
`;
const CheckClickFrame = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const CheckOffFrame = styled.div`
  width: 24px;
  height: 24px;
  background-color: #d9d9d9;
  border-radius: 99px;
  border: solid 1px #aaaaaa;
  @media (max-width: 1099px) {
    width: 18px;
    height: 18px;
  }
`;


const CheckOnFrame = styled.img`
  width: 24px;
  @media (max-width: 1099px) {
    width: 18px;
  }
`;

const CheckText = styled.div`
  font-family: Gongim-Medium;
  font-size: 20px;
  color: #707070;
  @media (max-width: 1099px) {
    font-size: 16px;
  }
`;


const SubContentFrame = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  @media (max-width: 1099px) {
    gap: 10px;
  }
`;
const SubTitleFrame = styled.div`
  display: flex;
  justify-content: space-between;
`;
const SubTitle = styled.div`
  font-family: Gongim-Medium;
  font-size: 32px;
  @media (max-width: 1099px) {
    font-size: 18px;
  }
`;
const CallFrame = styled.div`
  border-radius: 99px;
  padding-right: 20px;
  height: 42px;
  background-color: #349dec;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;
  @media (max-width: 1099px) {
    height: 26px;
    gap: 3px;
    padding-right: 10px;
    margin-top: -2px;
  }
`;

const CallText = styled.div`
  font-family: Gongim-Medium;
  font-size: 20px;
  color: #fff;
  @media (max-width: 1099px) {
    font-size: 15px;
  }
`;
const CallText02 = styled.div`
  font-family: Gongim-Medium;
  font-size: 20px;
  color: #fff;
  @media (max-width: 1099px) {
    display: none;
  }
`;

const Call = styled.img`
  height: 100%;
`;

const TableFrame = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top: solid 2px #99a5ac;
  box-sizing: content-box;
`;

const TableRow = styled.div`
  width: 100%;
  border-bottom: solid 2px #ddd;
  box-sizing: content-box;
  padding: 28px 0;
  display: flex;
  justify-content: start;
  gap: 80px;

  @media (max-width: 767px) {
    border-bottom: none;
    flex-direction: column;
    padding: 0;
    gap: 0px;
  }
`;
const TableGroup = styled.div`
  width: 510px;
  display: flex;
  justify-content: start;
  align-items: center;
  @media (max-width: 1099px) {
    width: 100%;
  }
  @media (max-width: 767px) {
    padding: 28px 0;
    border-bottom: solid 2px #ddd;
  }
`;

const TableLeftTitle = styled.div`
  width: 150px;
  font-family: Gongim-Medium;
  font-size: 20px;
  text-align: left;
  color: #333;
  ${(props) =>
    props.vali ?
      css`
      color: #EB3F3D;
    ` :
      css`
      color: #333;
    `
  }
  @media (max-width: 1099px) {
    width: 104px;

    font-size: 16px;
  }
`;

const RadioFrame = styled.div`
  display: flex;
  gap: 40px;
  @media (max-width: 767px) {
    flex-direction: column;
    gap: 16px;
  }
`;

const RadioContentFrame = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const RadioOn = styled.div`
  width: 24px;
  height: 24px;
  background-color: #fff;
  border: 6px solid #585858;
  border-radius: 99px;
  @media (max-width: 1099px) {
    width: 16px;
    height: 16px;
    border: 4px solid #585858;
  }
`;

const RadioOff = styled.div`
  width: 24px;
  height: 24px;
  background-color: #d9d9d9;
  border: 1px solid #aaa;
  border-radius: 99px;
  @media (max-width: 1099px) {
    width: 16px;
    height: 16px;
  }
`;

const RadioText = styled.div`
  font-family: Gongim-Reguler;
  font-size: 18px;
  color: #707070;
  @media (max-width: 1099px) {
    font-size: 15px;
  }
`;

const TextInfut = styled.input`
  width: 260px;
  height: 40px;
  padding: 0 20px;
  border: 1px solid #707070;
  color: #333;
  font-family: Gongim-Medium;
  font-size: 16px;
  ${(props) =>
    props.vali === true ?
      css`
      border: 1px solid #EB3F3D;
      color: #EB3F3D;
    ` :
      css`
      border: 1px solid #707070;
      color: #333;
    `
  }
  @media (max-width: 1099px) {
    width: 100%;
    border-radius: 0;
    height: 36px;
    flex: 1;
    font-size: 14px;
    padding: 0 12px;
  }
`;

const CarSelect = styled.select`
  -moz-appearance:none; /* Firefox */
  -webkit-appearance:none; /* Safari and Chrome */
  appearance:none;
  background: url(${Car}) no-repeat 95% 50%;
  width: 260px;
  height: 40px;
  padding: 0 20px;
  border: 1px solid #707070;
  color: #333;
  font-family: Gongim-Medium;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  align-items: center;
  border-radius :none;
  ${(props) =>
    props.vali === true ?
      css`
      border: 1px solid #EB3F3D;
      color: #EB3F3D;
    ` :
      css`
      border: 1px solid #707070;
      color: #333;
    `
  }
  @media (max-width: 1099px) {
    border-radius: 0;
    height: 36px;
    flex: 1;
    font-size: 14px;
    padding: 0 12px;
  }
`;

const CarImg = styled.img`
  width: 22px;
  @media (max-width: 1099px) {
    width: 18px;
  }
`;

const ButtonLine = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 0 0 80px 0;
  @media (max-width: 1099px) {
    gap: 10px;
    padding: 36px 0;
  }
`;

const ButtonRed = styled.div`
  width: 230px;
  height: 50px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #eb3f3d;
  color: #fff;
  font-family: Gongim-Medium;
  font-size: 20px;
  cursor: pointer;
  @media (max-width: 1099px) {
    flex: 1;
    height: 40px;
    font-size: 18px;
  }
`;

const ButtonBack = styled.div`
  width: 230px;
  height: 50px;
  border-radius: 4px;
  border: 1px solid #707070;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  color: #707070;
  font-family: Gongim-Medium;
  font-size: 20px;
  cursor: pointer;
  @media (max-width: 1099px) {
    flex: 1;
    height: 40px;
    font-size: 18px;
  }
`;


const CallTextNew = styled.div`
  font-family: Gongim-Medium;
  font-size: 20px;
  color: #333333;
  cursor: pointer;
  display: flex;
  align-items: center;
  @media(max-width: 768px) {
    display: none;
  }
`;

const CallTextNewMobile = styled.div`
  display: none;
  @media(max-width: 768px) {
    display: block;
    cursor: pointer;
    padding: 3px 10px;
    font-size: 13px;
    font-family: Gongim-Medium;
    color: #349DEC;
    border: 1px solid #349DEC;
    border-radius: 999px;
  }
`

// const GuideFrame = styled.div`
//   display: flex;
//   flex-direction: row;
//   justify-content: space-between;
//   align-items: center;
//   padding: 22px 30px;
//   width: 100%;
//   height: 80px;
//   background: linear-gradient(270.83deg, #3195E0 0%, #2EC3F2 100%);
//   flex: none;
//   order: 0;
//   flex-grow: 1;
// `;
//
// const GuideMainText = styled.h1`
//   font-family: Gongim-Medium;
//   font-style: normal;
//   font-weight: 500;
//   font-size: 28px;
//   line-height: 130%;
//   display: flex;
//   align-items: center;
//   color: #FFFFFF;
//   flex: none;
//   order: 0;
//   flex-grow: 0;
// `;




export default function Content01(props) {
  const [CheckState, setCheck] = useState(false);
  const [Radio01, setRadio01] = useState(false);
  const [Radio02, setRadio02] = useState(true);
  const [Radio03, setRadio03] = useState(false);
  const [assignType, setAssignType] = useState(null);

  const [car01, setCar01] = useState(true);
  const [car02, setCar02] = useState(false);


  const [phoneNo, setPhoneNo] = useState('');
  const [brand, setBrand] = useState('국산');
  const [vehicleModel, setVehicleModel] = useState('');
  const [carNo, setCarNo] = useState('');


  const [phoneNoVali, setPhoneNoVali] = useState(false);
  const [brandVali, setBrandVali] = useState(false);
  const [modelVali, setmodelVali] = useState(false);
  const [carNoVali, setCarNoVali] = useState(false);


  const navigate = useNavigate();
  const path = useLocation();
  const dispatch = useDispatch();
  let data = useSelector((state) => state.counter.data.data);
  let fin = useSelector((state) => state.counter.data.complate);
  let PDdata = useSelector((state) => state.counter.data.PDdata);
  let PD = useSelector((state) => state.counter.data.assignType);


  if (fin === true) {
    window.location.replace('/fin')
  }

  useEffect(() => {
    setAssignType(data.assignType);
    setPhoneNo(data.user.phoneNo);
    setVehicleModel(data.routes[0].car.vehicleModel);
    setCarNo(data.routes[0].car.carNo);
  }, [])

  useEffect(() => {
    if (assignType === 1) {
      setRadio01(true);
      setRadio02(false);
      setRadio03(false);
    } else if (assignType === 3) {
      setRadio01(false);
      setRadio02(true);
      setRadio03(false);
    } else if (assignType === 2) {
      setRadio01(false);
      setRadio02(false);
      setRadio03(true);
    }
  }, [assignType])

  useEffect(() => {
    if (brand === '국산') {
      setCar01(true);
      setCar02(false);
    } else if (brand === '외산') {
      setCar01(false);
      setCar02(true);
    }
  }, [brand])


  dispatch(nowPage(path.pathname))

  let payload = {
    requestOrderType: 2,
    callType: 3,
    user: {
      type: 2,
      name: '',
      phoneNo: phoneNo,
      branchCode: '',
      checkType: 2,
    },
    refTransNo: '',
    transNo: '',
    productType: 2,
    productServiceType: 1,
    routes: [
      {
        locationName: '',
        phoneNo: '',
        addr: '',
        addrDetail: '',
        lat: '',
        lon: '',
        locationType: '001',
        car: {
          brand: brand,
          vehicleModel: vehicleModel,
          carNo: carNo,
        },
      },
      {
        locationName: '',
        phoneNo: '',
        addr: '',
        addrDetail: '',
        lat: '',
        lon: '',
        locationType: '009',
        car: {},
      }
    ], //  필요 값: locationName (이름), phoneNo (연락처), addr (출발지주소), addrDetail(주소상세), locationType (001:출발지 , 009:도착지)
    reservationDate: '', // 예약 일자
    assignType: assignType, // 배차유형
    assignDetail: '', // 배차유형 상세 (P: 픽업, D: 딜리버리)
    serviceType: '0',
    customCostStatus: 1,
    roundTrip: 'N',
    memo: '',
    remark: '', // 전달사항 (요금 상세내역 입력 {} <- 사용);
    payType: 2
  }

  const nextPage = async () => {
    // console.log(payload)
    if (CheckState === false) {
      alert("개인정보 제3자 제공에 동의 해주세요");
    } else if (phoneNo === '' && brand === '' && vehicleModel === '' && carNo === '') {
      setPhoneNoVali(true);
      setBrandVali(true);
      setmodelVali(true);
      setCarNoVali(true);
      alert("필수 입력란을 전부 입력해주세요")
    } else if (phoneNo.length > 11 || phoneNo.length < 9 || phoneNo === '' || phoneNo === undefined) {
      setPhoneNoVali(true);
      alert("전화번호를 입력해주세요");
    } else if (brand === '' || brand === undefined) {
      setBrandVali(true);
      alert("제조사를 선택해주세요");
    } else if (vehicleModel === '' || vehicleModel === undefined) {
      setmodelVali(true);
      alert("차량모델을 입력해주세요");
    } else if (carNo === '' || carNo === undefined) {
      setCarNoVali(true);
      alert("차량번호를 입력해주세요");
    } else if (/^\d{2,3}[가-힣]{1,2}\d{3,4}$/g.test(String(carNo)) === false) {
      setCarNoVali(true);
      alert("차량번호가 잘못되었습니다.");
    } else {
     if (assignType === 2) {
       dispatch(PDdataChange(payload));
       dispatch(PDorderAssignType({ pickAndDeli: 2, pickup: 2, deli: 2 }))
     }

     //sentry 유저 정보
     Sentry.setUser({
       "id": phoneNo,
       "차량번호": carNo
     });

     //mixpanel 유저 정보
     mixpanel.identify(phoneNo);
     mixpanel.people.set({
      "name": phoneNo,
      "차량번호" : carNo
    });
     mixpanel.track('메인에서 확인 버튼을 클릭');
     dispatch(PDorderAssignType({ pickAndDeli: 0, pickup: assignType, deli: assignType }))
     dispatch(dataChange(payload));
     navigate('/address');
   }

  }

  const TranceCheck = () => {
    if (CheckState === true) {
      setCheck(false);
    } else {
      setCheck(true);
    }
  };

  const TranceRadio01 = () => {
    setAssignType(1);
    setRadio01(true);
    setRadio02(false);
    setRadio03(false);
  };

  const TranceRadio02 = () => {
    setAssignType(3);
    setRadio01(false);
    setRadio02(true);
    setRadio03(false);
  };

  const TranceRadio03 = () => {
    setAssignType(2);
    setRadio01(false);
    setRadio02(false);
    //////////////etRadio03(true);
  };


  const carRadio01 = () => {
    setBrand("국산");
    setCar01(true);
    setCar02(false);
  }
  const carRadio02 = () => {
    setBrand("외산");
    setCar01(false);
    setCar02(true);
  }
  return (
    <ContentFrame>
      <InfoFrame>
        <InfoTopFrame>
          <InfoTitle>제 3자 정보 제공 동의 내용</InfoTitle>
          <InfoContents>
            1. 개인정보를 제공받는 자 : 와이더블유모바일(주) <br />
            2. 개인정보를 제공받는 자의 개인정보 이용 목적 : 고객 주문 및 결제 <br />
            3. 제공하는 개인정보의 항목 : 전화번호, 차량정보, 결제 정보 <br />
            4. 개인정보를 제공받는 자의 개인정보 보유 및 이용 기간 : 제공 후 1년
          </InfoContents>
        </InfoTopFrame>
        <InfoBottomFrame>
          <CheckClickFrame onClick={TranceCheck}>
            {CheckState || <CheckOffFrame />}
            {CheckState && <CheckOnFrame src={Check} />}
            <CheckText>개인정보 제3자 제공에 동의 합니다.</CheckText>
          </CheckClickFrame>
        </InfoBottomFrame>
      </InfoFrame>
      <SubContentFrame>
        <SubTitleFrame>
          <SubTitle>공.딜 예약하기</SubTitle>
          <CallTextNew onClick={() => {document.location.href='tel:1599-7030'}}>전화 주문 1599-7030</CallTextNew>
          <CallTextNewMobile onClick={() => {document.location.href='tel:1599-7030'}}>전화 주문</CallTextNewMobile>
          {/*<CallFrame style={{ cursor: "pointer" }} onClick={() => {document.location.href='tel:1599-7030'}}>*/}
          {/*  <Call src={CallItem} />*/}
          {/*  <CallText>전화 주문</CallText>*/}
          {/*  <CallText02>1599-7030</CallText02>*/}
          {/*</CallFrame>*/}
        </SubTitleFrame>
        <TableFrame>
          <TableRow>
            <TableGroup style={{ width: "auto" }}>
              <TableLeftTitle>이동 유형</TableLeftTitle>
              <RadioFrame>
                <RadioContentFrame onClick={TranceRadio02}>
                  {Radio02 && <RadioOn />}
                  {Radio02 || <RadioOff />}
                  <RadioText>차량 보내기 (딜리버리)</RadioText>
                </RadioContentFrame>
                <RadioContentFrame onClick={TranceRadio01}>
                  {Radio01 && <RadioOn />}
                  {Radio01 || <RadioOff />}
                  <RadioText>차량 가져오기 (픽업)</RadioText>
                </RadioContentFrame>
                {/* <RadioContentFrame onClick={TranceRadio03}>
                  {Radio03 && <RadioOn />}
                  {Radio03 || <RadioOff />}
                  <RadioText>왕복 (픽업&딜리버리)</RadioText>
                </RadioContentFrame> */}
              </RadioFrame>
            </TableGroup>
          </TableRow>
          <TableRow>
            <TableGroup>
              <TableLeftTitle vali={phoneNoVali}>전화번호</TableLeftTitle>
              <TextInfut vali={phoneNoVali} value={phoneNo} onChange={(e) => { setPhoneNo(e.target.value.replace(/\D/g, '')) }} placeholder="휴대폰 번호를 입력하세요."></TextInfut>
            </TableGroup>
            <TableGroup>
              <TableLeftTitle vali={brandVali}>국산/외산</TableLeftTitle>
              <RadioFrame>
                <RadioContentFrame onClick={carRadio01}>
                  {car01 && <RadioOn />}
                  {car01 || <RadioOff />}
                  <RadioText>국산</RadioText>
                </RadioContentFrame>
                <RadioContentFrame onClick={carRadio02}>
                  {car02 && <RadioOn />}
                  {car02 || <RadioOff />}
                  <RadioText>외산</RadioText>
                </RadioContentFrame>
              </RadioFrame>
              {/* <TableLeftTitle vali={brandVali}>제조사</TableLeftTitle> */}
              {/* <CarSelect vali={brandVali} value={brand} onChange={(e) => {setBrand(e.target.value)}} placeholder="제조사를 선택해주세요">
                <CarImg src={Car} />
                <option value="">차량 제조사를 선택하세요</option>
                <option value="현대">현대</option>
                <option value="제네시스">제네시스</option>
                <option value="기아">기아</option>
                <option disabled>--------------</option>
                <option value="BMW">BMW</option>
              </CarSelect> */}
            </TableGroup>
          </TableRow>
          <TableRow>
            <TableGroup>
              <TableLeftTitle vali={modelVali}>차량 모델</TableLeftTitle>
              <TextInfut vali={modelVali} value={vehicleModel} onChange={(e) => { setVehicleModel(e.target.value) }} placeholder="차량 모델 정보를 입력하세요."></TextInfut>
            </TableGroup>
            <TableGroup>
              <TableLeftTitle vali={carNoVali}>차량 번호</TableLeftTitle>
              <TextInfut vali={carNoVali} value={carNo} onChange={(e) => { setCarNo(e.target.value) }} placeholder="00가0000"></TextInfut>
            </TableGroup>
          </TableRow>
        </TableFrame>
      </SubContentFrame>
      <ButtonLine>
        <ButtonBack onClick={() => { }}>취소</ButtonBack>
        <ButtonRed onClick={() => { nextPage() }}>다음</ButtonRed>
      </ButtonLine>
    </ContentFrame>
  );
}



//data: {
// "callType":4,
// "user":{"type":2,
//          "id":"0",
//          "name":"",
//          "phoneNo":"01063841983",
//          "branchCode":"",
//          "deptName":"",
//          "checkType":2
//  },
//  "productType":2,
//  "productServiceType":1,
//  "routes":[{"locationName":"","phoneNo":"","addr":"경기 안산시 단원구 초지동 691-2","addrDetail":"공임나라 안산고잔점","lat":"37.3150066690419","lon":"126.820398907561"},{"locationName":"","phoneNo":"","addr":"경기 의왕시 포일동 28","addrDetail":"의왕정음학교","lat":"","lon":""}]},


// \^\d{2,3}[가-힣]\d{3,4}\g.test(carNo);
